const transitionTimingFunction = 'cubic-bezier(0.4, 0, 0.2, 1)'

export const transitionStyles = {
  themeChange: `all 0.5s ${transitionTimingFunction}`,
}
